/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateOrgUserDTO } from '../models/CreateOrgUserDTO';
import type { CreateOrgUserOut } from '../models/CreateOrgUserOut';
import type { OrgUserIdDTO } from '../models/OrgUserIdDTO';
import type { OrgUserOut } from '../models/OrgUserOut';
import type { PropelUserModel } from '../models/PropelUserModel';
import type { UpdateOrgUserDTO } from '../models/UpdateOrgUserDTO';
import type { UserCredentialsOut } from '../models/UserCredentialsOut';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserService {
  /**
   * Get Users
   * @returns PropelUserModel Successful Response
   * @throws ApiError
   */
  public static getUsers(): CancelablePromise<Array<PropelUserModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/users',
    });
  }

  /**
   * Get Org Users
   * @returns OrgUserOut Successful Response
   * @throws ApiError
   */
  public static getOrgUsers(): CancelablePromise<Array<OrgUserOut>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/users/org',
    });
  }

  /**
   * Update Org User
   * @param requestBody
   * @returns OrgUserOut Successful Response
   * @throws ApiError
   */
  public static updateOrgUser(requestBody: UpdateOrgUserDTO): CancelablePromise<OrgUserOut> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/users/org',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Create Org User
   * @param requestBody
   * @returns CreateOrgUserOut Successful Response
   * @throws ApiError
   */
  public static createOrgUser(requestBody: CreateOrgUserDTO): CancelablePromise<CreateOrgUserOut> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/users/org',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Block Org User
   * @param requestBody
   * @returns OrgUserOut Successful Response
   * @throws ApiError
   */
  public static blockOrgUser(requestBody: OrgUserIdDTO): CancelablePromise<OrgUserOut> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/users/org/block',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Unblock Org User
   * @param requestBody
   * @returns OrgUserOut Successful Response
   * @throws ApiError
   */
  public static unblockOrgUser(requestBody: OrgUserIdDTO): CancelablePromise<OrgUserOut> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/users/org/unblock',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Reset Org User Password
   * @param requestBody
   * @returns UserCredentialsOut Successful Response
   * @throws ApiError
   */
  public static resetOrgUserPassword(requestBody: OrgUserIdDTO): CancelablePromise<UserCredentialsOut> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/users/org/reset-password',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
